{
  "pt": {
    "sales": {
      "actions": {
        "assign_lead": "Atribuir um líder",
        "publish": "Publicar",
        "remove_lead_from_deal": "Remover chumbo do negócio",
        "unpublish": "Cancelar a publicação",
        "update_status": "Atualizar o estado",
        "upload_document": "Carregar contrato",
        "view_contracts": "Ver contratos"
      },
      "attributes": {
        "status": "Estado"
      },
      "labels": {
        "assign_customer": "Atribuir cliente",
        "assign_customer_mark_sold": "Atribuir cliente para marcar como vendido",
        "assign_lead_to_unit": "Atribuir um chefe de fila à unidade",
        "assigned_by": "Atribuído por",
        "contracts": "Contratos",
        "expiry_date": "Data de expiração da reserva",
        "go_to_unit_part_1": "Esta unidade foi vendida. Se quiser atualizar o estado, tem de ir à página",
        "go_to_unit_part_2": "e anular a atribuição do cliente nesse local, como medida de segurança.",
        "interested_leads": "{count} contactos interessados",
        "internal_note": "Nota interna",
        "latest_phase": "Última fase",
        "lead_existing": "Chumbo existente",
        "lead_new": "Novo chumbo",
        "leads_count": "{count} contactos",
        "mark_as_sold": "Marcar como vendido",
        "not_published_sales_partners": "Não publicado para parceiros de vendas",
        "not_shown_interest": "Este contacto não demonstrou interesse em nenhuma unidade",
        "note_explainer": "Esta nota só é visível para a sua equipa",
        "publish_unit": "Publicar 1 unidade para todos os parceiros de vendas | Publicar {count} unidades para todos os parceiros de vendas ",
        "published_sales_partners": "Publicado para parceiros de vendas",
        "reserved_by": "Reservado por",
        "reserved_warning": "Esta unidade está atualmente reservada por {lead_name}. Se marcar esta unidade como vendida, esta reserva será cancelada.",
        "sales": "Vendas",
        "selling_price": "Preço de venda",
        "selling_price_max": "Preço de venda máximo",
        "selling_price_min": "Preço de venda mínimo",
        "sold_date": "Vendido em",
        "sorting": {
          "deal_lead_group_name": "Chumbo",
          "deal_status": "Estado",
          "name": "Unidade"
        },
        "status": "Estado",
        "statuses": {
          "available": "Disponível",
          "interested": "Interessado",
          "lost": "Perdido",
          "reserved": "Reservado",
          "sold": "Vendido"
        },
        "tab_sales_documents": "Documentos",
        "tab_sales_tickets": "Conversas",
        "tab_sales_units": "Unidades",
        "unit": "Unidade",
        "unit_information_page": "página de informações da unidade",
        "unit_sales_status_header": "Esta unidade está à venda",
        "unpublish_unit": "Cancelar a publicação de 1 unidade para todos os parceiros de vendas | Cancelar a publicação de {count} unidades para todos os parceiros de vendas ",
        "update_sales_status": "Atualizar o estado das vendas de unidades",
        "upload_sales_doc": "Carregar contrato"
      },
      "toasts": {
        "lead_assigned": "Chumbo atribuído"
      },
      "validation": {
        "already_reserved_sold": "Esta unidade já está reservada para outro cliente principal!",
        "already_reserved_sold_info": "Se tiver certeza de que deseja alterar o status do lead atual, primeiro é preciso alterar o status do negócio que tem prioridade no momento. Depois de alterar o status do outro negócio, você pode voltar e atualizar o status com segurança.",
        "need_sold_date": "Necessita da data desta venda",
        "reserved_expiry_date": "Necessita de uma data de expiração para esta reserva"
      }
    }
  }
}
